import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { TsPdfUrlApi, TsPdfUrlRequest, TsPdfUrlResponse } from '../ts-pdf-url-api';
import { GuestAwareHttpService } from '../../services/guest-aware-http-service';

@injectable()
export class TsPdfUrlApiImpl extends GuestAwareHttpService implements TsPdfUrlApi {
    async getPdfUrl(request: TsPdfUrlRequest): Promise<TsPdfUrlResponse> {
        const res = await this.getWithGuestSupport<TsPdfUrlResponse>(
            'ts/pdf_url',
            { ts_code: request.ts_code, version: request.version }
        );
        return res;
    }
}
